import Immutable from "seamless-immutable";
import {
  POST_LOGIN_REQUEST,
  POST_LOGIN_SUCCESS,
  POST_LOGIN_FAILURE,
  POST_CONFIRM_LOGIN_REQUEST,
  POST_CONFIRM_LOGIN_SUCCESS,
  POST_CONFIRM_LOGIN_FAILURE,
  SET_AUTH_TOKEN,
  POST_FORGOT_USER_ID_REQUEST,
  POST_FORGOT_USER_ID_SUCCESS,
  POST_FORGOT_USER_ID_FAILURE,
  GET_CURRENT_USER_ID_REQUEST,
  GET_CURRENT_USER_ID_SUCCESS,
  GET_CURRENT_USER_ID_FAILURE,
  RESEND_OTP_REQUEST,
  RESEND_OTP_SUCCESS,
  RESEND_OTP_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_REQUEST_SUCCESS,
  FORGOT_PASSWORD_REQUEST_FAILURE,
  VERIFY_FORGOT_PASS_OTP_REQUEST,
  VERIFY_FORGOT_PASS_OTP_SUCCESS,
  VERIFY_FORGOT_PASS_OTP_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  LOGIN_PORTAL_REQUEST,
  LOGIN_PORTAL_SUCCESS,
  LOGIN_PORTAL_FAILURE,
  GET_AUTHORIZATION_AUTH,
  GET_AUTHORIZATION_AUTH_SUCCESS,
  GET_AUTHORIZATION_AUTH_FAILURE,
  GET_AUTH_TOKEN_REQUEST,
  GET_AUTH_TOKEN_SUCCESS,
  GET_AUTH_TOKEN_FAILURE,
  GET_SINGPASS,
  GET_SINGPASS_SUCCESS,
  GET_SINGPASS_FAILURE,
  GET_MAINTENANCE_MSG,
  GET_MAINTENANCE_MSG_SUCCESS,
  GET_MAINTENANCE_MSG_FAILURE,
  GENERATE_LOGIN_OTP,
  GENERATE_LOGIN_OTP_SUCCESS,
  GENERATE_LOGIN_OTP_FAILURE,
} from "../actions/auth";

const INITIAL_STATE = Immutable({
  login: null,
  confirmLogin: null,
  authToken: null,
  forgotUserId: null,
  getUserId: null,
  resendOtp: null,
  forgotPassReq: null,
  forgotPassOtp: null,
  changePassword: null,
  loginPortal: null,
  getAuthorizationAuth: null,
  authToken: null,
  getSingPass: null,
  getMaintenanceMsg: null,
  generateLoginOTP:null,
});

function auth(state = INITIAL_STATE, action) {
  switch (action.type) {
    case POST_LOGIN_REQUEST:
      return state
        .setIn(["login", "loading"], true)
        .setIn(["login", "status"], false);
    case POST_LOGIN_SUCCESS:
      return state
        .setIn(["login", "loading"], false)
        .setIn(["login", "items"], action.data)
        .setIn(["login", "status"], true);
    case POST_LOGIN_FAILURE:
      return state
        .setIn(["login", "loading"], false)
        .setIn(["login", "status"], false);
    case POST_CONFIRM_LOGIN_REQUEST:
      return state
        .setIn(["confirmLogin", "loading"], true)
        .setIn(["confirmLogin", "status"], false);
    case POST_CONFIRM_LOGIN_SUCCESS:
      return state
        .setIn(["confirmLogin", "loading"], false)
        .setIn(["confirmLogin", "items"], action.data)
        .setIn(["confirmLogin", "status"], true);
    case POST_CONFIRM_LOGIN_FAILURE:
      return state
        .setIn(["confirmLogin", "loading"], false)
        .setIn(["confirmLogin", "status"], false);
    case SET_AUTH_TOKEN:
      return state.setIn(["authToken"], action.authToken);
    case POST_FORGOT_USER_ID_REQUEST:
      return state
        .setIn(["forgotUserId", "loading"], true)
        .setIn(["forgotUserId", "status"], false);
    case POST_FORGOT_USER_ID_SUCCESS:
      return state
        .setIn(["forgotUserId", "loading"], false)
        .setIn(["forgotUserId", "items"], action.data)
        .setIn(["forgotUserId", "status"], true);
    case POST_FORGOT_USER_ID_FAILURE:
      return state
        .setIn(["forgotUserId", "loading"], false)
        .setIn(["forgotUserId", "status"], false);
    case GET_CURRENT_USER_ID_REQUEST:
      return state
        .setIn(["getUserId", "loading"], true)
        .setIn(["getUserId", "status"], false);
    case GET_CURRENT_USER_ID_SUCCESS:
      return state
        .setIn(["getUserId", "loading"], false)
        .setIn(["getUserId", "items"], action.data)
        .setIn(["getUserId", "status"], true);
    case GET_CURRENT_USER_ID_FAILURE:
      return state
        .setIn(["getUserId", "loading"], false)
        .setIn(["getUserId", "status"], false);
    case RESEND_OTP_REQUEST:
      return state
        .setIn(["resendOtp", "loading"], true)
        .setIn(["resendOtp", "status"], false);
    case RESEND_OTP_SUCCESS:
      return state
        .setIn(["resendOtp", "loading"], false)
        .setIn(["resendOtp", "items"], action.data)
        .setIn(["resendOtp", "status"], true);
    case RESEND_OTP_FAILURE:
      return state
        .setIn(["resendOtp", "loading"], false)
        .setIn(["resendOtp", "status"], false);
    case FORGOT_PASSWORD_REQUEST:
      return state
        .setIn(["forgotPassReq", "loading"], true)
        .setIn(["forgotPassReq", "status"], false);
    case FORGOT_PASSWORD_REQUEST_SUCCESS:
      return state
        .setIn(["forgotPassReq", "loading"], false)
        .setIn(["forgotPassReq", "items"], action.data)
        .setIn(["forgotPassReq", "status"], true);
    case FORGOT_PASSWORD_REQUEST_FAILURE:
      return state
        .setIn(["forgotPassReq", "loading"], false)
        .setIn(["forgotPassReq", "status"], false);
    case VERIFY_FORGOT_PASS_OTP_REQUEST:
      return state
        .setIn(["forgotPassOtp", "loading"], true)
        .setIn(["forgotPassOtp", "status"], false);
    case VERIFY_FORGOT_PASS_OTP_SUCCESS:
      return state
        .setIn(["forgotPassOtp", "loading"], false)
        .setIn(["forgotPassOtp", "items"], action.data)
        .setIn(["forgotPassOtp", "status"], true);
    case VERIFY_FORGOT_PASS_OTP_FAILURE:
      return state
        .setIn(["forgotPassOtp", "loading"], false)
        .setIn(["forgotPassOtp", "status"], false);
    case CHANGE_PASSWORD_REQUEST:
      return state
        .setIn(["changePassword", "loading"], true)
        .setIn(["changePassword", "status"], false);
    case CHANGE_PASSWORD_SUCCESS:
      return state
        .setIn(["changePassword", "loading"], false)
        .setIn(["changePassword", "items"], action.data)
        .setIn(["changePassword", "status"], true);
    case CHANGE_PASSWORD_FAILURE:
      return state
        .setIn(["changePassword", "loading"], false)
        .setIn(["changePassword", "status"], false);
    case LOGIN_PORTAL_REQUEST:
      return state
        .setIn(["loginPortal", "loading"], true)
        .setIn(["loginPortal", "status"], false);
    case LOGIN_PORTAL_SUCCESS:
      return state
        .setIn(["loginPortal", "loading"], false)
        .setIn(["loginPortal", "items"], action.data)
        .setIn(["loginPortal", "status"], true);
    case LOGIN_PORTAL_FAILURE:
      return state
        .setIn(["loginPortal", "loading"], false)
        .setIn(["loginPortal", "status"], false);
    case GET_AUTHORIZATION_AUTH:
      return state
        .setIn(["getAuthorizationAuth", "loading"], true)
        .setIn(["getAuthorizationAuth", "status"], false);
    case GET_AUTHORIZATION_AUTH_SUCCESS:
      return state
        .setIn(["getAuthorizationAuth", "loading"], false)
        .setIn(["getAuthorizationAuth", "items"], action.data)
        .setIn(["getAuthorizationAuth", "status"], true);
    case GET_AUTHORIZATION_AUTH_FAILURE:
      return state
        .setIn(["getAuthorizationAuth", "loading"], false)
        .setIn(["getAuthorizationAuth", "status"], false);
    case GET_SINGPASS:
      return state
        .setIn(["getSingPass", "loading"], true)
        .setIn(["getSingPass", "status"], false);
    case GET_SINGPASS_SUCCESS:
      return state
        .setIn(["getSingPass", "loading"], false)
        .setIn(["getSingPass", "items"], action.data)
        .setIn(["getSingPass", "status"], true);
    case GET_SINGPASS_FAILURE:
      return state
        .setIn(["getSingPass", "loading"], false)
        .setIn(["getSingPass", "status"], false);
    case GET_MAINTENANCE_MSG:
      return state
        .setIn(["getMaintenanceMsg", "loading"], true)
        .setIn(["getMaintenanceMsg", "status"], false);
    case GET_MAINTENANCE_MSG_SUCCESS:
      return state
        .setIn(["getMaintenanceMsg", "loading"], false)
        .setIn(["getMaintenanceMsg", "items"], action.data)
        .setIn(["getMaintenanceMsg", "status"], true);
    case GET_MAINTENANCE_MSG_FAILURE:
      return state
        .setIn(["getMaintenanceMsg", "loading"], false)
        .setIn(["getMaintenanceMsg", "status"], false);

    case GENERATE_LOGIN_OTP:
      return state
        .setIn(["generateLoginOTP", "loading"], true)
        .setIn(["generateLoginOTP", "status"], false);
    case GENERATE_LOGIN_OTP_SUCCESS:
      return state
        .setIn(["generateLoginOTP", "loading"], false)
        .setIn(["generateLoginOTP", "items"], action.data)
        .setIn(["generateLoginOTP", "status"], true);
    case GENERATE_LOGIN_OTP_FAILURE:
      return state
        .setIn(["generateLoginOTP", "loading"], false)
        .setIn(["generateLoginOTP", "status"], false);
    case GET_AUTH_TOKEN_REQUEST:
      return state.setIn(["authToken", "loading"], true);
    case GET_AUTH_TOKEN_SUCCESS:
      return state
        .setIn(["authToken", "loading"], false)
        .setIn(["authToken", "items"], action.data)
        .setIn(["authToken", "status"], true);
    case GET_AUTH_TOKEN_FAILURE:
      return state.setIn(["authToken", "loading"], false);
    default:
      return state;
  }
}

export default auth;
